// src/component/ProposalCard.jsx
import React from "react";
import PDFSingleThumbnail from "./component/PDFSingleThumbnail";

export default function ProposalCard({
                                         item,
                                         pageNumber,
                                         onPreview,
                                         onDelete,
                                     }) {
    const thumbnailUrl = item.thumbnailPath || item.path;

    const handleClickCard = () => {
        if (onPreview) {
            onPreview(item, pageNumber);
        }
    };

    const handleClickDelete = (e) => {
        e.stopPropagation();
        if (onDelete) {
            onDelete(item.id);
        }
    };

    return (
        <div
            // ★ bg-white로 배경색, border + rounded-lg로 테두리, hover:shadow 등
            className="bg-white border border-gray-300 rounded-lg hover:shadow-2xl transition cursor-pointer"
            onClick={handleClickCard}
        >
            {/* 상단 정보 */}
            <div className="px-4 pt-3">
                <p className="text-sm text-gray-700 font-medium truncate">
                    {item.name}
                    {pageNumber && (
                        <span className="ml-1 text-xs text-blue-500">
              (p.{pageNumber})
            </span>
                    )}
                </p>
                <div className="flex flex-wrap gap-1 mt-1">
                    {item.tags?.map((tg, idx) => (
                        <span
                            key={idx}
                            className="bg-gray-100 text-xs px-2 py-1 rounded-full"
                        >
              {tg.trim()}
            </span>
                    ))}
                </div>
            </div>

            {/* 썸네일 영역 */}
            <div className="h-[500px] w-full bg-gray-100 flex items-center justify-center overflow-hidden">
                {pageNumber ? (
                    <PDFSingleThumbnail
                        pdfUrl={item.path}
                        pageNumber={pageNumber}
                        scale={1.3}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <img
                        src={`${process.env.REACT_APP_API_REAL_URL}/${thumbnailUrl}`}
                        alt={item.name}
                        className="w-full h-full object-cover"
                    />
                )}
            </div>

            {/* 하단 버튼들 */}
            <div className="flex justify-end gap-1 p-2">
                <button
                    className="p-1 text-gray-600 hover:text-red-500"
                    onClick={handleClickDelete}
                >
                    삭제
                </button>
            </div>
        </div>
    );
}